module.exports = __webpack_public_path__ + "img/2025-11-17c_13.5c28db8d.jpg";